import { Tooltip } from "./Tooltip.tsx";
import { band, bandText } from "../../lib/semantics.ts";

interface HealthRingProps {
  percentage: number;
  size?: number;
  strokeWidth?: number;
  showLabel?: boolean;
  tooltip?: string;
}

export function HealthRing({ percentage, size = 48, strokeWidth = 4, showLabel = true, tooltip }: HealthRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  const color = bandText(band(percentage, "readiness"));
  const trackColor = "text-surface-tertiary";

  const ring = (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg className="transform -rotate-90" width={size} height={size}>
        <circle
          className={`stroke-current ${trackColor}`}
          fill="none"
          strokeWidth={strokeWidth}
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
        <circle
          className={`stroke-current ${color} transition-all duration-500`}
          fill="none"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          r={radius}
          cx={size / 2}
          cy={size / 2}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
        />
      </svg>
      {showLabel && (
        <span className={`absolute text-[13px] font-medium ${color}`}>
          {percentage}%
        </span>
      )}
    </div>
  );

  return tooltip ? <Tooltip text={tooltip}>{ring}</Tooltip> : ring;
}
